import React, { useEffect, useState } from 'react';
import api from "../../utils/axiosInstance";
import AdminSideMenu from '../../components/AdminSideMenu';
import AssignPackageModal from "./AssignPackageModal";
import { useNavigate } from 'react-router-dom';
import { FaToggleOn, FaToggleOff, FaTrash, FaEye, FaEdit } from 'react-icons/fa';
import Select from 'react-select';

const CarrierListing = () => {
    const navigate = useNavigate();
    const [carriers, setCarriers] = useState([]);
    const [filteredCarriers, setFilteredCarriers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentCarrier, setCurrentCarrier] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [packages, setPackages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCarriers, setTotalCarriers] = useState(0);
    const itemsPerPage = 18;
    const [selectedLogo, setSelectedLogo] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [isAssignOpen, setIsAssignOpen] = useState(false);

    const [assignPackages, setAssignPackages] = useState([]);
    const [assignCarriers, setAssignCarriers] = useState([]);


    const trailerOptions = [
        { value: 'Van', label: 'Van' },
        { value: 'Flatbed', label: 'Flatbed' },
        { value: 'Reefer', label: 'Reefer' },
        { value: 'Tanker', label: 'Tanker' },
        { value: 'Other', label: 'Other' },
    ];
    const stateOptions = [
        "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
        "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana",
        "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana",
        "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina",
        "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
        "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
        "Wisconsin", "Wyoming"
    ];

    useEffect(() => {
        fetchCarriers();
        assignPackageFunc();
    }, []);

    useEffect(() => {
        fetchPackages();
    }, []);

    const fetchPackages = async () => {
        try {
            const res = await api.get('/packageSubscribed/all-carriers');
            setPackages(res.data);
        } catch (err) {
            console.error('Failed to fetch packages:', err);
        }
    };

    const assignPackageFunc = async () => {
        let queryParams = `page=${1}&limit=${500}`;
        const res = await api.get(`/carriers?${queryParams}`);
        const carriersData = res.data.carriers || res.data || [];
        const carrierOptions = carriersData.map(carrier => ({
            label: carrier.companyName,
            value: carrier.id || carrier._id
        }));
        setAssignCarriers(carrierOptions);
        const packagesData = await api.get('/packages');
        const packagesArr = packagesData.data || [];
        const packageOptions = packagesArr.filter(packag => packag.isActive).map(packag => ({
            label: packag.name,
            value: packag.id || packag._id,
            duration: packag.duration
        }));
        setAssignPackages(packageOptions);
    };

    const getPackageDetails = (carrierId) => {
        const subscription = packages.find(sub => String(sub.carrierId) === String(carrierId));

        if (subscription) {
            return `${subscription.packageName}`;
        }

        return 'No Package Subscribed';
    };

    const handleResetSession = async () => {
        try {
            await api.patch(`/carriers/${currentCarrier._id}/reset-session`);
            alert('Login reset successfull.');

            setCurrentCarrier(prev => ({
                ...prev,
                activeToken: null,
                tokenCreatedAt: null,
                activeDeviceId: null,
                sessionActive: false,
            }));

        } catch (error) {
            alert('Failed to reset session/token');
            console.error(error);
        }
    };

    const fetchCarriers = async (page = 1, search = '') => {
        try {
            let queryParams = `page=${page}&limit=${itemsPerPage}`;

            if (search.trim()) {
                queryParams += `&search=${encodeURIComponent(search.trim())}`;
            }

            const res = await api.get(`/carriers?${queryParams}`);

            // Handle both old and new response formats
            const carriersData = res.data.carriers || res.data || [];
            const pagination = res.data.pagination || {};

            setCarriers(carriersData);
            setFilteredCarriers(carriersData);
            setTotalPages(pagination.totalPages || 1);
            setTotalCarriers(pagination.totalCount || carriersData.length);
            setCurrentPage(page);
        } catch (err) {
            console.error('Failed to fetch carriers:', err);
            setCarriers([]);
            setFilteredCarriers([]);
            setTotalPages(1);
            setTotalCarriers(0);
        }
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedLogo(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setLogoPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleToggleStatus = async (id, currentStatus) => {
        try {
            const newStatus = currentStatus === 'Active' ? false : true;
            await api.put(`/carriers/toggle-status/${id}`, {
                isActive: newStatus,
            });
            fetchCarriers(currentPage, searchTerm);
        } catch (err) {
            console.error('Status toggle failed:', err);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this carrier?')) {
            try {
                await api.delete(`/carriers/${id}`);
                const newPage = filteredCarriers.length === 1 && currentPage > 1
                    ? currentPage - 1
                    : currentPage;
                fetchCarriers(newPage, searchTerm);
            } catch (err) {
                console.error('Delete failed:', err);
            }
        }
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchCarriers(1, searchTerm);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchTerm]);

    const openModal = (carrier, edit = false) => {
        setCurrentCarrier(carrier);
        setIsEditMode(edit);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentCarrier(null);
        setSelectedLogo(null);
        setLogoPreview(null);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCurrentCarrier(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        try {
            const formData = new FormData();

            const excludeFields = ['_id', '__v', 'createdAt', 'updatedAt', 'assignedDrivers', 'companyLogo'];

            Object.keys(currentCarrier).forEach(key => {
                if (excludeFields.includes(key)) return;

                const value = currentCarrier[key];

                if (key === 'trailer') {
                    if (Array.isArray(value)) {
                        value.forEach(t => formData.append('trailer', t));
                    } else if (value) {
                        formData.append('trailer', value);
                    }
                } else if (value !== null && value !== undefined && value !== '') {
                    formData.append(key, value);
                }
            });

            if (selectedLogo) {
                formData.append('companyLogo', selectedLogo);
            }

            await api.put(`/carriers/${currentCarrier._id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            fetchCarriers(currentPage, searchTerm);
            setIsModalOpen(false);
            setSelectedLogo(null);
            setLogoPreview(null);
            alert('Carrier updated successfully');
        } catch (err) {
            console.error('Failed to update carrier:', err);
            alert('Update failed: ' + (err.response?.data?.message || err.message));
        }
    };

    const handleButtonSave = async (data) => {
        let response = await api.post(`/packageSubscribed/bypas-subscription`, data);
        return response.data;
    }

    return (
        <div className="flex flex-col md:flex-row">
            <AdminSideMenu />
            <div className="md:ml-64 p-4 md:p-8 w-full bg-gray-50 min-h-screen">
                <header className="pb-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2">
                    <div>
                        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Carriers</h1>
                        <p className="text-gray-600">Manage your carriers here</p>
                    </div>
                </header>

                <div className="mb-6 flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex flex-[3] align-center">
                        <input
                            type="text"
                            placeholder="Search by Company name, Fleety ID or Phone"
                            className="w-full md:w-1/2 px-4 py-2 border rounded-lg shadow"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {totalCarriers > 0 && (
                            <div className="px-6 text-sm font-semibold text-gray-800">
                                Showing {filteredCarriers.length} of {totalCarriers} carriers
                            </div>
                        )}
                    </div>
                    <div className="flex gap-4 justify-between">
                        <button
                            onClick={() => navigate('/admin/add-carrier')}
                            className="bg-blue-600 text-white px-5 py-2 rounded shadow hover:bg-blue-700 transition"
                        >
                            Add Carrier
                        </button>
                        <button
                            onClick={() => setIsAssignOpen(true)}
                            className="bg-blue-600 text-white px-5 py-2 rounded shadow hover:bg-blue-700 transition"
                        >
                            Assign Package
                        </button>
                        <button
                            onClick={() => navigate('/admin/driver-assign')}
                            className="bg-blue-600 text-white px-5 py-2 rounded shadow hover:bg-blue-700 transition"
                        >
                            Assign Driver
                        </button>
                    </div>
                </div>


                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {filteredCarriers.length === 0 ? (
                        <div className="col-span-full text-center text-gray-500 text-lg py-12">
                            No records found
                        </div>
                    ) : (
                        filteredCarriers.map((carrier) => (
                            <div key={carrier._id} className="bg-white p-6 rounded-xl shadow border border-l-4 border-l-blue-600 relative">
                                <div className="absolute top-4 right-4 flex gap-2">
                                    <button onClick={() => openModal(carrier, false)} className="text-blue-600 hover:scale-110" title="View">
                                        <FaEye />
                                    </button>
                                    <button onClick={() => openModal(carrier, true)} className="text-green-600 hover:scale-110" title="Edit">
                                        <FaEdit />
                                    </button>
                                    <button onClick={() => handleToggleStatus(carrier._id, carrier.status)} title="Toggle Status">
                                        {carrier.status === 'Active' ? <FaToggleOn className="text-green-600" /> : <FaToggleOff className="text-blue-600" />}
                                    </button>
                                    <button onClick={() => handleDelete(carrier._id)} className="text-blue-600 hover:scale-110" title="Delete">
                                        <FaTrash />
                                    </button>
                                </div>
                                <div className="flex items-center gap-4 mb-3">
                                    <img
                                        src={carrier.companyLogo ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${carrier.companyLogo}` : './assets/dummy-icon.jpeg'}
                                        alt={`${carrier.companyName || 'Company'} Logo`}
                                        className="w-12 h-12 rounded-full object-cover"
                                    />
                                    <div>
                                        <h3 className="text-lg font-bold break-words">{carrier.companyName}</h3>
                                        <span className={`text-xs font-medium ${carrier.status === 'Active' ? 'text-green-600' : 'text-blue-600'}`}>{carrier.status}</span>
                                    </div>
                                </div>
                                <p className="text-sm">Fleety ID: {carrier.identificationNumber}</p>
                                <p className="text-sm">
                                    Contact: {carrier.contactName && carrier.contactName.trim() !== '' ? carrier.contactName : 'N/A'}
                                </p>
                                <p className="text-sm break-all">Email: {carrier.email}</p>
                                <p className="text-sm">
                                    ZIP Code: {carrier.zip && carrier.zip.trim() !== '' ? carrier.zip : 'N/A'}
                                </p>
                                <p className="text-sm">Phone: <span className="font-bold">{carrier.phone}</span></p>
                                <p className="text-sm">
                                    Date of Join: <span className="font-bold">
                                        {new Date(carrier.createdAt).toLocaleDateString('en-US')}
                                    </span>
                                </p>
                                <p className="text-sm">
                                    Package: <span className="font-bold text-blue-600">{getPackageDetails(carrier._id)}</span>
                                </p>
                            </div>
                        ))
                    )}
                </div>

                {totalPages > 1 && (
                    <div className="flex justify-center mt-6">
                        <nav className="flex items-center space-x-1 bg-white px-4 py-3 rounded-xl shadow-md">
                            <button
                                onClick={() => fetchCarriers(Math.max(1, currentPage - 1), searchTerm)}
                                disabled={currentPage === 1}
                                aria-label="Previous page"
                                className={`w-9 h-9 flex items-center justify-center rounded-full transition-all border text-xl
                ${currentPage === 1
                                        ? 'bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed'
                                        : 'bg-gray-50 text-gray-500 border-gray-300 hover:bg-blue-100 hover:text-blue-700'}`}
                            >
                                &lt;
                            </button>

                            {/* Page numbers with ellipsis */}
                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter(page =>
                                    page === 1 ||
                                    page === totalPages ||
                                    (page >= currentPage - 2 && page <= currentPage + 2)
                                )
                                .map((page, idx, arr) => {
                                    const prev = arr[idx - 1];
                                    return (
                                        <React.Fragment key={page}>
                                            {prev && page - prev > 1 && (
                                                <span className="w-9 h-9 flex items-center justify-center text-gray-500">...</span>
                                            )}
                                            <button
                                                onClick={() => fetchCarriers(page, searchTerm)}
                                                aria-current={currentPage === page ? 'page' : undefined}
                                                className={`w-9 h-9 rounded-full flex items-center justify-center mx-0.5 text-base transition-all font-semibold border
                                 ${currentPage === page
                                                        ? 'bg-blue-600 text-white shadow border-blue-600'
                                                        : 'bg-gray-50 text-gray-900 border-gray-300 hover:bg-blue-100 hover:text-blue-700'}`}
                                            >
                                                {page}
                                            </button>
                                        </React.Fragment>
                                    );
                                })}

                            <button
                                onClick={() => fetchCarriers(Math.min(totalPages, currentPage + 1), searchTerm)}
                                disabled={currentPage === totalPages}
                                aria-label="Next page"
                                className={`w-9 h-9 flex items-center justify-center rounded-full transition-all border text-xl
                ${currentPage === totalPages
                                        ? 'bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed'
                                        : 'bg-gray-50 text-gray-500 border-gray-300 hover:bg-blue-100 hover:text-blue-700'} `}
                            >
                                &gt;
                            </button>
                        </nav>
                    </div>
                )}

                {/* ---- VIEW MODAL ---- */}
                {isModalOpen && currentCarrier && !isEditMode && (
                    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
                        <div className="bg-white max-w-2xl w-full p-8 rounded-2xl shadow-2xl relative overflow-y-auto max-h-[90vh]">
                            <button onClick={closeModal} className="absolute top-5 right-6 text-2xl text-gray-500 hover:text-blue-700 transition">
                                <i className="fas fa-times"></i>
                            </button>
                            <div className="flex flex-col items-center mb-5">
                                <img
                                    src={currentCarrier.companyLogo ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${currentCarrier.companyLogo}` : '/assets/dummy-icon.jpeg'}
                                    alt={(currentCarrier.companyName || 'Company') + ' Logo'}
                                    className="w-28 h-28 rounded-full shadow border-4 border-blue-200 object-cover mb-3 bg-gray-50"
                                />
                                <h2 className="text-3xl font-extrabold mb-1">{currentCarrier.companyName || '-'}</h2>
                                <div className="flex gap-4 items-center flex-wrap">
                                    <span className={`px-4 py-1 rounded-full text-xs font-bold ${currentCarrier.status === "Active" ? "bg-green-100 text-green-600" : "bg-blue-100 text-blue-600"}`}>
                                        {currentCarrier.status}
                                    </span>
                                    <span className="bg-gray-200 py-1 px-3 rounded-full text-xs text-black">Fleety ID: {currentCarrier.identificationNumber}</span>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-8 gap-y-4 text-base">
                                <div>
                                    <div className="font-semibold text-gray-600">Contact Person</div>
                                    <div className="font-bold">{currentCarrier.contactName || <span className="opacity-60">N/A</span>}</div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-600">Job Title</div>
                                    <div className="font-bold">{currentCarrier.jobTitle || <span className="opacity-60">N/A</span>}</div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-600">Email</div>
                                    <div className="font-bold">{currentCarrier.email || <span className="opacity-60">N/A</span>}</div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-600">Phone</div>
                                    <div className="font-bold">{currentCarrier.phone || <span className="opacity-60">N/A</span>}</div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-600">City</div>
                                    <div className="font-bold">{currentCarrier.city || <span className="opacity-60">N/A</span>}</div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-600">ZIP Code</div>
                                    <div className="font-bold">{currentCarrier.zip || <span className="opacity-60">N/A</span>}</div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-600">Trailer</div>
                                    <div className="font-bold">
                                        {Array.isArray(currentCarrier.trailer) && currentCarrier.trailer.length > 0
                                            ? currentCarrier.trailer.join(", ")
                                            : <span className="opacity-60">N/A</span>
                                        }
                                    </div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-600">Website</div>
                                    <div className="font-bold">{currentCarrier.website || <span className="opacity-60">N/A</span>}</div>
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-600">Address</div>
                                    <div className="font-bold">{currentCarrier.address || <span className="opacity-60">N/A</span>}</div>
                                </div>
                                {(() => {
                                    const pkg = getPackageDetails(currentCarrier._id);
                                    const match = pkg.match(/^(.+?)\s*\((.+)\)$/);
                                    const pkgName = match ? match[1] : pkg;
                                    const pkgDuration = match ? match[2] : "N/A";
                                    return (
                                        <>
                                            <div>
                                                <div className="font-semibold text-gray-600">Package Name</div>
                                                <div className="font-bold text-blue-600">{pkgName}</div>
                                            </div>
                                            <div />
                                        </>
                                    );
                                })()}

                                <div className="sm:col-span-3">
                                    <div className="font-semibold text-gray-600">Company Description</div>
                                    <div className="font-bold">{currentCarrier.companyDesc || <span className="opacity-60">N/A</span>}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ---- EDIT MODAL ---- */}
                {isModalOpen && currentCarrier && isEditMode && (
                    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl md:text-2xl font-bold">Edit Carrier</h2>
                                <button onClick={closeModal} className="text-xl text-gray-500"><i className="fas fa-times"></i></button>
                            </div>
                            <form className="space-y-5">

                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Company Name</div>
                                    <input
                                        type="text"
                                        name="companyName"
                                        value={currentCarrier.companyName || ''}
                                        onChange={handleInputChange}
                                        placeholder="Company Name"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Trailer</div>
                                    <Select
                                        isMulti
                                        name="trailer"
                                        value={trailerOptions.filter(opt =>
                                            Array.isArray(currentCarrier.trailer)
                                                ? currentCarrier.trailer.includes(opt.value)
                                                : currentCarrier.trailer === opt.value
                                        )}
                                        options={trailerOptions}
                                        onChange={selected => {
                                            const values = selected ? selected.map(s => s.value) : [];
                                            handleInputChange({ target: { name: 'trailer', value: values } });
                                        }}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select trailer types"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Contact Name</div>
                                    <input
                                        type="text"
                                        name="contactName"
                                        value={currentCarrier.contactName || ''}
                                        onChange={handleInputChange}
                                        placeholder="Contact Name"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Job Title</div>
                                    <input
                                        type="text"
                                        name="jobTitle"
                                        value={currentCarrier.jobTitle || ''}
                                        onChange={handleInputChange}
                                        placeholder="Job Title"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Email</div>
                                    <input
                                        type="email"
                                        name="email"
                                        value={currentCarrier.email || ''}
                                        onChange={handleInputChange}
                                        placeholder="Email"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Phone</div>
                                    <input
                                        type="text"
                                        name="phone"
                                        value={currentCarrier.phone || ''}
                                        onChange={handleInputChange}
                                        placeholder="Phone"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Address</div>
                                    <input
                                        type="text"
                                        name="address"
                                        value={currentCarrier.address || ''}
                                        onChange={handleInputChange}
                                        placeholder="Address"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">City</div>
                                    <input
                                        type="text"
                                        name="city"
                                        value={currentCarrier.city || ''}
                                        onChange={handleInputChange}
                                        placeholder="City"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">State</div>
                                    <div className="input-with-icon relative">
                                        <i className="fas fa-flag-usa absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
                                        <select
                                            id="state"
                                            name="state"
                                            value={currentCarrier.state || ''}
                                            onChange={handleInputChange}
                                            className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-md text-base focus:border-primary focus:outline-none focus:ring-2 focus:ring-yellow-200"
                                        >
                                            <option value="">Select state</option>
                                            {stateOptions.map(st => (
                                                <option key={st} value={st}>{st}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">ZIP Code</div>
                                    <input
                                        type="text"
                                        name="zip"
                                        value={currentCarrier.zip || ''}
                                        onChange={handleInputChange}
                                        placeholder="ZIP Code"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Website</div>
                                    <input
                                        type="text"
                                        name="website"
                                        value={currentCarrier.website || ''}
                                        onChange={handleInputChange}
                                        placeholder="Website"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Company Description</div>
                                    <input
                                        type="text"
                                        name="companyDesc"
                                        value={currentCarrier.companyDesc || ''}
                                        onChange={handleInputChange}
                                        placeholder="Company Description"
                                        className="w-full border px-4 py-2 rounded"
                                    />
                                </div>
                                <div className="space-y-1">
                                    <div className="font-semibold text-gray-600">Company Logo</div>

                                    <div className="mb-3">
                                        <img
                                            src={logoPreview || (currentCarrier.companyLogo
                                                ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${currentCarrier.companyLogo}`
                                                : '/assets/dummy-icon.jpeg')}
                                            alt="Company Logo"
                                            className="w-24 h-24 rounded-full object-cover border-2 border-gray-300"
                                        />
                                    </div>

                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleLogoChange}
                                        className="w-full border px-4 py-2 rounded file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:bg-blue-600 file:text-white hover:file:bg-blue-700"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">Upload a new logo (JPG, PNG, max 5MB)</p>
                                </div>
                            </form>

                            <div className="flex justify-between items-center mt-6">
                                <button
                                    type="button"
                                    onClick={handleResetSession}
                                    className="px-4 py-2 bg-black rounded text-white font-semibold hover:bg-blue-700"
                                >
                                    Reset Login
                                </button>
                                <button
                                    onClick={handleSave}
                                    className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* --- ASSIGN PACKAGE STARTS */}
                <AssignPackageModal
                    isOpen={isAssignOpen}
                    onClose={() => setIsAssignOpen(false)}
                    assignCarriers={assignCarriers}
                    assignPackages={assignPackages}
                    handleButtonSave={handleButtonSave}
                />
                {/* {isAssignOpen && (
                    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl md:text-2xl font-bold">Assign Package to Carrier</h2>
                                <button onClick={()=>setIsAssignOpen(false)} className="text-xl text-gray-500"><i className="fas fa-times"></i></button>
                            </div>
                            
                        </div>
                    </div>
                )} */}
                {/* --- ASSIGN PACKAGE ENDS */} 
            </div>
        </div>
    );
};

export default CarrierListing;
